import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
import { markAicopyHomePromoShown, shouldShowAicopyHomePromo } from "@/utils/aicopyHomePromo";
import promoBg from "@/assets/images/home/aicopyPromo/promo-bg.png";
import promoIcon from "@/assets/images/home/aicopyPromo/promo-ai-icon.png";
import styles from "./index.module.less";

const { useTranslation } = Hooks;

const FOLLOW_STRATEGY_ID = "21";

function textOf(t, key, fallback) {
  const value = t(key);
  if (!value || value === key) return fallback;
  return value;
}

export default function AicopyHomePromo() {
  const t = useTranslation();
  const router = useRouter();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!shouldShowAicopyHomePromo()) return undefined;
    const timerId = window.setTimeout(() => {
      markAicopyHomePromoShown();
      setOpen(true);
    }, 600);
    return () => window.clearTimeout(timerId);
  }, []);

  if (!open) return null;

  const close = () => setOpen(false);

  const goFollow = () => {
    setOpen(false);
    router.push({
      pathname: "/aicopy",
      query: { followStrategyId: FOLLOW_STRATEGY_ID },
    });
  };

  return (
    <div className={styles.overlay} role="presentation" onClick={close}>
      <div
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="aicopy-home-promo-title"
        style={{ backgroundImage: `url(${promoBg})` }}
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className={styles.close} aria-label="Close" onClick={close}>
          ×
        </button>
        <div className={styles.promo}>
          <h2 id="aicopy-home-promo-title" className={styles.headline}>
            {textOf(t, "home.aicopyPromoTitle", "锁仓Claude，享双重奖励")}
          </h2>
          <div className={styles.iconWrap}>
            <img className={styles.icon} src={promoIcon} alt="" />
          </div>
          <div className={styles.card}>
            <span className={styles.prefix}>{textOf(t, "home.aicopyPromoCashPrefix", "最高")}</span>
            <span className={styles.pct}>10%</span>
            <span className={styles.label}>{textOf(t, "home.aicopyPromoCashLabel", "真金奖励券")}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.prefix}>{textOf(t, "home.aicopyPromoExpPrefix", "再享最高")}</span>
            <span className={styles.pct}>80%</span>
            <span className={styles.label}>{textOf(t, "home.aicopyPromoExpLabel", "跟单体验金券")}</span>
          </div>
          <p className={styles.body}>
            {textOf(
              t,
              "home.aicopyPromoBody",
              "新增充值并锁仓Claude，体验金与本金同步参与策略。完成锁仓周期后，解锁真金奖励，并领取体验金产生的实际收益。"
            )}
          </p>
          <div className={styles.btnWrap}>
            <button type="button" className={styles.btn} onClick={goFollow}>
              {textOf(t, "home.aicopyPromoCta", "立即跟单")}
            </button>
          </div>
          <p className={styles.footnote}>
            {textOf(
              t,
              "home.aicopyPromoFootnote",
              "体验金本金不可提现；实际净盈利按50%分配给用户，无净盈利则无收益可领取。"
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
